import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(value?: string | Date | null, options?: Intl.DateTimeFormatOptions): string {
  if (!value) return '—'
  return new Intl.DateTimeFormat('en-NG', options ?? { dateStyle: 'medium' }).format(new Date(value))
}

export function formatDateTime(value?: string | Date | null): string {
  if (!value) return '—'
  return new Intl.DateTimeFormat('en-NG', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value))
}

export function initials(name?: string): string {
  return (name || 'W')
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
}

export function money(minor?: number | null, currency = 'NGN'): string {
  if (minor === null || minor === undefined) return '—'
  return new Intl.NumberFormat('en-NG', { style: 'currency', currency }).format(minor / 100)
}
